import { render, staticRenderFns } from "./OnboardingClaimAthleteProfile.vue?vue&type=template&id=1a2fdd78&"
import script from "./OnboardingClaimAthleteProfile.vue?vue&type=script&lang=ts&"
export * from "./OnboardingClaimAthleteProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports